// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__2RL4T"};